"use client";

import { ONETRUST_TRACKING_GROUP } from "@/constants/tracking";
import { GoogleTagManager } from "@next/third-parties/google";
import { useRouter } from "next/navigation";
import Script from "next/script";
import { useEffect, useState } from "react";

export default function CookieConsentBanner({
  gtmId,
}: {
  readonly gtmId: string;
}) {
  const [showGoogleTagManager, setShowGoogleTagManager] = useState(false);
  const router = useRouter();

  useEffect(() => {
    function handleConsent() {
      const trackingGroup = ONETRUST_TRACKING_GROUP;

      if (!window.OnetrustActiveGroups) return;

      if (window.OnetrustActiveGroups.includes(trackingGroup)) {
        setShowGoogleTagManager(true);
        setTimeout(() => router.refresh(), 1000); // Wait for GTM to load
      }
    }

    window.addEventListener("OTConsentApplied", handleConsent);

    return () => window.removeEventListener("OTConsentApplied", handleConsent);
  }, [router]);

  return (
    <>
      {/* OneTrust Cookies Consent Notice start for urbansportsclub.com */}
      <Script
        type="text/javascript"
        src="https://cdn.cookielaw.org/consent/8fa64c9d-3fb5-49f2-aaf1-fe359812a4d1/OtAutoBlock.js"
      />
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-document-language="true"
        type="text/javascript"
        data-domain-script="8fa64c9d-3fb5-49f2-aaf1-fe359812a4d1"
      />
      <Script type="text/javascript" id="optanon-wrapper">
        {`function OptanonWrapper() { }`}
      </Script>
      {/* OneTrust Cookies Consent Notice end for urbansportsclub.com */}
      {showGoogleTagManager && <GoogleTagManager gtmId={gtmId} />}
    </>
  );
}
